'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(DisplayPreferences2) {
  DisplayPreferences2["MIXED"] = "mixed";
  DisplayPreferences2["LANDSCAPE"] = "landscape";
  DisplayPreferences2["PORTRAIT"] = "portrait";
})(exports.DisplayPreferences || (exports.DisplayPreferences = {}));
(function(CategorySlugs2) {
  CategorySlugs2["LAST_PLAYED"] = "last-played";
  CategorySlugs2["FAVOURITES"] = "favourites";
})(exports.CategorySlugs || (exports.CategorySlugs = {}));
(function(DynamicRecommendationsCategoryValues2) {
  DynamicRecommendationsCategoryValues2["USER"] = "user";
  DynamicRecommendationsCategoryValues2["MARKET"] = "market";
  DynamicRecommendationsCategoryValues2["GAME"] = "game-recommendations";
})(exports.DynamicRecommendationsCategoryValues || (exports.DynamicRecommendationsCategoryValues = {}));
